var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vwrap"},[_c('link',{attrs:{"href":"//vjs.zencdn.net/7.8.2/video-js.min.css","rel":"stylesheet"}}),_c('video',{ref:"videoPlayer",staticClass:"video-js",class:{'vjs-16-9':!_vm.b.small},style:({ width: '100%', marginTop: '0px'}),attrs:{"playsinline":"","webkit-playsinline":"","muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }